import { appName } from "../../copy/sq";

export function TopBar({ title }: { title: string }) {
  return (
    <header className="sticky top-0 z-20 flex items-center justify-between border-b border-ink-100 bg-paper/90 px-4 py-3 backdrop-blur lg:hidden">
      <p className="font-serif text-base font-semibold text-ink-950">{title}</p>
      <p className="text-xs font-medium uppercase tracking-wide text-ink-400">{appName.short}</p>
    </header>
  );
}
